import { useEffect, useState } from "react";
import { Box, Typography, Stack, Grid} from "@mui/material"
// import { ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';
import { FeatureState } from "../../global/GlobalFcn";
import { StartUpperCase } from "../../global/Format";
import { GetToolMostUsedPage } from "../../../global/API";
import { UsedPageLoader } from "../../loader/Loader";

export const UsedPage = ({__SESSION, graphDatasets}) => {
    
    const [mostPages, setMostPages] = useState({
        loader:false,
        data:[]
    })

    // SAMPLE DATA RESULT
    // let res_data = [ 
    //     {feature_name:"dashboard",path:"1", count:1, },
    //     {feature_name:"bcloud",path:"2", count:2},
    //     {feature_name:"recently",path:"2->1", count:3},
    //     {feature_name:"registration",path:"2->2", count:4},
    //     {feature_name:"contracts",path:"2->3", count:5},
    //     {feature_name:"my-documents",path:"2->4", count:6},
    //     {feature_name:"shared-documents",path:"2->5", count:7},
    //     {feature_name:"favorites",path:"2->6", count:8},
    //     {feature_name:"trash",path:"2->7", count:9},
    //     {feature_name:"policies",path:"3", count:10},
    //     {feature_name:"category",path:"3->1", count:11},
    //     {feature_name:"team",path:"3->2", count:12},
    //     {feature_name:"concern",path:"3->3", count:13},
    //     {feature_name:"general-maintenance",path:"4", count:14},
    //     {feature_name:"company-setup",path:"4->1", count:15},
    //     {feature_name:"number-sequence",path:"4->2", count:16},
    //     {feature_name:"master-list",path:"4->3", count:17},
    //     {feature_name:"position",path:"4->3->2", count:18},
    //     {feature_name:"department",path:"4->3->1", count:18},
    //     {feature_name:"user",path:"4->3->3", count:19},
    //     {feature_name:"client",path:"4->3->4", count:20},
    //     {feature_name:"user-role",path:"4->4", count:20},
    //     {feature_name:"hero",path:"5", count:21},
    //     {feature_name:"tool-categories",path:"6", count:22}
    // ]

    const getMostUsedPage = async() => {
        
        setMostPages((prev) => ({...prev, 
            loader:true
        }))
       
        if (graphDatasets.data.dates.length > 0) {
            let qsp = {
                company_id:__SESSION.data.uaccess[0]?.company_id,
                tool_id:parseInt(process.env.REACT_APP_TID_BIZ),
                user_id:graphDatasets.data.assigned_id === 0 ? parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]) : graphDatasets.data.assigned_id,
                date_from:graphDatasets.data?.start_date,
                date_to:graphDatasets.data?.last_date,
            }
            
            let res_data = await GetToolMostUsedPage(qsp)

            let role_type = graphDatasets.data.assigned_id === 0 ? __SESSION.data.uaccess[0]?.role_name : graphDatasets.data.role_name
            let ftrdata = await FeatureState('most-used-page', role_type) || console.log('Feature Name is Not Found!')
    
            const mergeArr = ftrdata.map((fd) => {
                const rd = res_data.find((rd) => fd.feature_name === rd.feature_name && fd.path === rd.path); 
                return {...fd, count:rd?.count || 0};
            });
    
            setMostPages((prev) => ({...prev, 
                data:mergeArr.sort((a, b) => b.count - a.count),
                loader:false
            }))
        }
    }

    useEffect(() => {
        getMostUsedPage()
        // eslint-disable-next-line
    }, [graphDatasets.data.dates])

    return (
        <Box sx={{bgcolor: "#fff", borderRadius: 4, p:4, border: 1, borderColor: "#cececeff"}}>
            <Stack sx={{gap: 3}}>
                <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Box sx={{display: "flex", gap: 1}}>
                        <Typography fontWeight={600}>Most Used Page</Typography>
                        <Typography sx={{fontWeight: 600, color: "primary.main"}}>Info</Typography>
                    </Box>
                </Box>
                <Box sx={{border: 1, borderColor: "#cececeff", width: "100%", height: "400px", borderRadius: 4, overflowY: "auto"}}>
                    <Grid container spacing={2} p={2}>
                        {mostPages.loader ? 
                            <UsedPageLoader/>
                        :
                            mostPages.data?.map((mp, i)=>(
                                <Grid item xs={3} key={i}>
                                    <Box sx={{border: 1, borderColor: "#cececeff", p: 2, borderRadius: 4}}>
                                        <Typography sx={{fontSize: 14, fontWeight: 800}}>{StartUpperCase(mp.feature_name)}</Typography>
                                        <Typography sx={{fontSize: 32, fontWeight: 800}}>{mp.count}</Typography>
                                        {/* <Box display="flex">
                                            <ArrowDownwardIcon sx={{color: "primary.main"}}/>
                                            <Typography color="#359418ff">2% Last 7 days</Typography>
                                        </Box> */}
                                    </Box>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Box>
            </Stack>
        </Box>
    )
}